import { Form, Input, Select } from "antd";

const InputSelect = ({
  rules,
  placeholder,
  label,
  classname,
  wrapClassname,
  option = [],
  name,
  onChange,
}) => {
  return (
    <Form.Item label={label} name={name} rules={rules}>
      <Select placeholder={placeholder} onChange={(e) => onChange?.(name, e)}>
        {option.map((item) => {
          return <Select.Option value={item.value}>{item.label}</Select.Option>;
        })}
      </Select>
    </Form.Item>
  );
};

export default InputSelect;
